var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAlertTriangleFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "7aa5h2ddra",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.823529 0 0 0 0 0.058824 0 0 0 0 0.196078 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#7aa5h2ddra)",
    transform: "translate(-41.000000, -256.000000) translate(24.000000, 105.500000) translate(0.000000, 33.000000) translate(17.000000, 54.000000) translate(0.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.448 0c.7 0 1.347.365 1.71.963l8.47 14.14c.355.615.357 1.373.006 1.99-.352.618-1.005 1.002-1.716 1.01H1.978c-.71-.008-1.364-.392-1.716-1.01-.351-.617-.35-1.375.006-1.99L8.738.963C9.101.365 9.748 0 10.448 0zm.01 13.103l-.127.006c-.497.058-.883.48-.883.994 0 .552.448 1 1 1l.127-.007c.497-.058.883-.48.883-.993 0-.553-.448-1-1-1zm-.01-8c-.552 0-1 .447-1 1v4l.007.116c.058.498.48.884.993.884.552 0 1-.448 1-1v-4l-.007-.117c-.057-.497-.48-.883-.993-.883z",
    transform: "translate(0.000000, 0.000000) translate(1.551981, 3.897256)"
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlertTriangleFilled);
export default __webpack_public_path__ + "static/media/ic-alert-triangle-filled.454891387c43c9277d626519f25cb228.svg";
export { ForwardRef as ReactComponent };